function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M474.3,133.981l-0.1-0.1c-4.1-3.7-10.4-3.7-14.3,0.2c-3.9,3.9-3.9,10.2,0,14.1c16.4,16.4,16.4,43,0,59.4 c-16.4,16.4-43,16.4-59.4,0c-0.2-0.2-0.3-0.3-0.5-0.4c-15-21-34.2-38.6-56.3-51.7c22.9-54-2.4-116.3-56.4-139.1 c-54-22.8-116.3,2.4-139.1,56.4c-4.6,11-7.4,22.7-8.2,34.6c-10.6-3-19.1-4.4-25.7-4.2c-10.6,0.1-18.4,6.7-19.6,16.4 c-0.7,4.3-0.2,10.6,2.1,31.1l2.1,19.6c-19.2,15.6-34.3,33.8-45.2,54.2l-29,5.7c-14.4,2.9-24.7,15.6-24.7,30.2v64.3 c0,14.7,10.3,27.3,24.7,30.2l29.1,5.8c5.7,11.2,12.7,21.7,20.9,31.3c-10.8,26.8-2.8,57.5,19.6,75.8c13.3,10.8,30,16.7,47.1,16.6 c19.5,0,38.3-7.4,52.6-20.7l7-6.6c25.8,3.9,52.2,3,77.7-2.4l9.9,9.5c13.7,12.9,31.9,20.1,50.7,19.9h2.1c0.1,0,0.2,0,0.3,0 c19.6-0.5,38.2-8.7,51.8-22.9c21-22.2,23.5-55.6,6.9-81.8c18.8-26.2,28.7-56.2,28.7-87.2v-7.3c0-0.2,0-0.4,0-0.6 c-0.9-14.9-4.8-30.3-11.6-45.9c20.5,4.4,41.9-1.9,56.7-16.8C498.4,197.381,498.4,158.181,474.3,133.981z M246,27.881 c47.5-0.1,86.1,38.3,86.2,85.8c0.1,28.7-14.2,55.6-38.1,71.6c-0.8,0.6-1.6,1.8-2.2,1.8h-91.4c-0.4,0-0.9-0.6-1.4-1 c-22.7-14.7-37.1-39.2-39.1-66.1c-0.2-2.3-0.2-4.3-0.2-6.1C159.9,66.481,198.4,27.981,246,27.881z M381,371.981 c-1.7,2-4.3,6.6-1.2,12.8c0.3,0.6,0.6,1.1,1,1.6c14.5,18.9,13.7,44.5-1.9,61c-9.9,10.3-23.3,16.7-37.8,16.7h-1.9 c-13.7,0.1-26.9-5-36.9-14.4l-13-12.4c-2.3-2.2-5.4-3.4-8.5-3.3c-0.8,0-1.5,0.1-2.3,0.3c-25.7,6.1-52.3,6.9-78.4,2.5 c-0.6-0.1-1.1-0.1-1.7-0.1c-3.2-0.1-6.2,1.1-8.5,3.3l-9.8,9.3c-10,9.3-22.9,14.6-36.5,15.2c-13.3,0.7-26.5-3.6-36.9-11.9 c-16.6-13.6-21.7-36.9-12.2-56.2c1.5-2.5,1.9-5.6,1.1-8.5c-0.4-1.8-1.2-3.4-2.4-4.7c-9.4-10.3-17.3-22-23.4-34.6 c-0.5-1-1.1-1.9-1.9-2.7c-1.9-2.1-4.4-3.4-7.1-3.9l-32.2-6.5c-5-1-8.6-5.5-8.6-10.6v-64.5c-0.1-5.1,3.5-9.6,8.6-10.6l32.3-6.5 c2.7-0.5,5.2-1.8,7.1-3.9c0.8-0.8,1.4-1.6,1.9-2.6c10.2-20.4,25.4-38.6,45.1-53.8c0.3-0.3,0.6-0.5,0.9-0.8 c2.3-2.3,3.5-5.4,3.4-8.6c0-0.4,0-0.7-0.1-1.1l-2.6-24c-0.9-7.7-2.4-21.6-2.2-25.4c0.1,0,0.3,0,0.4,0c4-0.1,11.7,0.6,25.9,5.2 c3,22.2,13,42.8,28.5,58.9h-9.5c-5.5,0-10,4.5-10,10s4.5,10,10,10H333c5.5,0,10-4.5,10-10s-4.5-10-10-10h-10.4 c4.4-4.3,8.3-9.1,11.6-14.3c23.1,14,42.1,32.8,55.2,54.4l7.1,13.7c7.3,15.1,11.5,30.4,12.5,44.4v6.9h0 C409,320.781,399.3,348.281,381,371.981z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M138.5,242.181c-14.2,0-25.6,11.5-25.6,25.6c0,14.2,11.5,25.6,25.6,25.6c14.1,0,25.6-11.5,25.6-25.6 C164.2,253.681,152.7,242.181,138.5,242.181z M138.5,273.481c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6 C144.2,270.981,141.7,273.481,138.5,273.481z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M246,53.281c-33.5,0-60.6,27.1-60.6,60.6c0.1,33.4,27.2,60.5,60.6,60.6c33.5,0,60.6-27.1,60.6-60.6 S279.5,53.281,246,53.281z M246,154.481c-22.4,0-40.6-18.2-40.6-40.6c0-22.4,18.2-40.6,40.6-40.6c22.4,0,40.6,18.2,40.6,40.6 C286.6,136.281,268.4,154.481,246,154.481z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var SvgMoney = function SvgMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492.363 492.363",
    style: {
      enableBackground: "new 0 0 492.363 492.363"
    },
    height: 40,
    width: 40,
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money.db2afde4.svg";
export { ForwardRef as ReactComponent };